import { SectionHeader } from "@/components/common/section-header";
import { CardGrid, Cards } from "@/types/dto/homepage/homepage-types";
import { Box, Divider, Stack, Typography } from "@mui/material";
import Image from "next/image";
import React from "react";

interface PrivateTourStepperProps {
  privateTouringWork: CardGrid;
  moduleRankingPosition: number;
}

const PrivateTourStepper = ({
  privateTouringWork,
  moduleRankingPosition
}: PrivateTourStepperProps) => (
  <Box
    component="section"
    className="fluid-width-container"
    data-testid="private-tour-stepper"
    data-parent-container="private-tours-stepper-section"
    data-module-ranking-position={moduleRankingPosition}
    data-module-name="private tour stepper"
    data-ranking-algorithm="manual"
    data-track="visibility"
    sx={{
      p: { xs: "4rem 2.4rem", sm: "4rem 3.2rem", md: "4rem 10rem" },
      bgcolor: "background.warm_strong",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "4rem"
    }}
  >
    <SectionHeader
      headerSx={{ textAlign: "center", color: "primary.main", textTransform: "none" }}
      headerTestId="stepper-header"
      headerText={privateTouringWork?.basicInfo?.headerText}
    />
    <Stack
      direction={{ xs: "column", sm: "row" }}
      gap="1.8rem"
      alignItems={{ xs: "center", md: "flex-start" }}
      justifyContent="center"
      sx={{
        display:"flex",
        justifyContent: "space-between",
        width:"100%"
      }}      
      className="destination-page-container"
      padding={{
        xs: "0 2.4rem",
        sm: "0 3.2rem",
        lg: "0 10rem"
      }}      
    >
      {privateTouringWork?.cards?.map((card: Cards, index: number) => (
        <Stack
          key={card.id}
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "center", md: "flex-start" }}
          gap="1.8rem"
          sx={{
            flex: index < 2 ? { xs: 0, sm: 1 } : 0
          }}
        >
          <Stack
            sx={{
              justifyContent: "center",
              alignItems: "center",
              gap: "1.6rem",
              width: {xs:"20rem", sm:"15rem", md:"16rem", xl:"25rem"}
            }}
          >
            {card.image?.imageUrl && (
              <Image
                data-testid={`private-tour-card-image-${index}`}
                src={card.image.imageUrl}
                alt={card.image.altText ?? ""}
                width={64}
                height={64}
              />
            )}
            <Typography
              data-testid={`private-tour-card-header-${index}`}
              variant="h5"
              sx={{ textAlign: "center", fontSize: "2rem", fontWeight: 600, color: "primary.main" }}
            >
              {card?.info?.headerText}
            </Typography>
          </Stack>
          {index < 2 && (
            <Divider
              data-testid={`private-tour-card-divider-${index}`}
              sx={{
                height: { xs: "6.2rem", sm: "0.2rem" },
                minHeight: { xs: "6.2rem", sm:"0.2rem" },
                width: { xs: "0.2rem", sm: "auto" },
                flex: { xs: 0, sm: "1 1 auto" },
                minWidth: { xs: "0.2rem", sm: "1rem" },
                bgcolor: "black",
                border: "none",
                mt: { xs: 0, sm: "3.1rem" }
              }}
            />
          )}
        </Stack>
      ))}
    </Stack>
  </Box>
);

export default PrivateTourStepper;